import script from "./inputNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputNumber.vue?vue&type=script&setup=true&lang=ts"

import "./inputNumber.vue?vue&type=style&index=0&id=24843584&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24843584"]])

export default __exports__